export const languages = ['fr', 'en'];
